// ** React Imports
import { Link } from "react-router-dom";
import { CheckCircle, Save, Delete, Info, PieChart, Edit } from "react-feather";
import { formatCurrency0Digit } from "../../../../../utility/Utils";

import classnames from "classnames";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { saveTransactionPaymentProof } from "../../action";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Fragment, useState } from "react";
const MySwal = withReactContent(Swal);

const handleConfirmText = ({ callbackFunction, itemSelect, title, text }) => {
  MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then(function (result) {
    if (result.value) {
      callbackFunction({ itemSelect });
    }
  });
};

const confirmRegistrationSuccess = ({ title, text }) => {
  MySwal.fire({
    title: title,
    text: text,
    icon: "success",
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const confirmRegistrationError = ({ statusCode, statusDesc }) => {
  MySwal.fire({
    title: "บันทึกข้อมูลไม่สำเร็จ",
    text: statusDesc,
    icon: "error",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const ProofCards = (props) => {
  const {
    data,
    setBlock,
    payment,
    dispatch,
    activeView,
    setActiveView,
    getCourses,
    transactionPaymentProofs,
    disabledDelete,
    setDisabledDelete,
  } = props;

  const [formModalImage, setFormModalImage] = useState(false);
  const [imageView, setImageView] = useState(null);

  function callBackFunction({ type, data }) {
    setBlock(false);
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({
        title: "บันทึกข้อมูลเรียบร้อย",
        text: "",
      });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  function savePaymentProof(itemSelect) {
    handleConfirmText({
      callbackFunction: saveProof,
      itemSelect: itemSelect,
      title: "ยืนยันบันทึกข้อมูล ใช่หรือไม่",
      text: "",
    });
  }

  function saveProof({ itemSelect }) {
    let transactionPaymentProof = {
      transactionCourseUserId: itemSelect.transactionCourseUserId,
      amount: itemSelect.amount,
      courseId: itemSelect.courseId,
      createBy: itemSelect.createBy,
      createDate: itemSelect.createDate,
      flag: "0",
      id: itemSelect.id,
      imageProof: itemSelect.imageProof,
      status: itemSelect.status,
      updateBy: itemSelect.updateBy,
      updateDate: itemSelect.updateDate,
      userId: itemSelect.userId,
      fileType: itemSelect.fileType,
      callBackFunction: callBackFunction,
    };
    saveTransactionPaymentProof(transactionPaymentProof);
  }

  function setImageViewFunction(image) {
    setImageView(image);
    setFormModalImage(!formModalImage);
  }

  // ** Renders products
  const renderCourses = () => {
    if (
      payment.transactionPaymentProofs &&
      payment.transactionPaymentProofs.length
    ) {
      return payment.transactionPaymentProofs.map((item) => {
        const text =
          item.uploadBy === "ROLE_USER"
            ? "จำนวนเงินที่ชำระค่าลงทะเบียน"
            : "จำนวนเงินที่โอนคืน";

        return (
          <div>
            <Card className="ecommerce-card" key={item.id}>
              <div className="item-img text-center mx-auto">
                <img
                  className="img-fluid card-img-top"
                  src={item.imageProof}
                  alt={item.name}
                  onClick={() => setImageViewFunction(item.imageProof)}
                />
              </div>
              <CardBody>
                <div className="item-wrapper">
                  <div className="item-cost">
                    <h6 className="item-price">
                      {item.fileType === "PROOF" &&
                      item.amount &&
                      item.amount > 0
                        ? text +
                          " " +
                          formatCurrency0Digit(item.amount) +
                          " บาท"
                        : item.fileType === "PROPERTY"
                        ? "ไฟล์หลักฐานคุณสมบัติ"
                        : ""}
                    </h6>
                  </div>
                </div>
              </CardBody>
              <div className="item-options text-center">
                <div className="item-wrapper">
                  <div className="item-cost">
                    <h4 className="item-price">
                      {item.fileType === "PROOF" &&
                      item.amount &&
                      item.amount > 0
                        ? text +
                          " " +
                          formatCurrency0Digit(item.amount) +
                          " บาท"
                        : item.fileType === "PROPERTY"
                        ? "ไฟล์หลักฐานคุณสมบัติ"
                        : ""}
                    </h4>
                  </div>
                </div>
                {disabledDelete && item.uploadBy === "ROLE_USER" ? (
                  <Button
                    color="flat-danger"
                    className="btn-wishlist bg-light-danger"
                    onClick={() => savePaymentProof(item)}
                  >
                    ลบ
                  </Button>
                ) : (
                  <div />
                )}
              </div>
            </Card>
          </div>
        );
      });
    }
  };

  return (
    <Fragment>
      <div
        className={classnames({
          "grid-view": activeView === "grid",
          "list-view": activeView === "list",
        })}
      >
        {renderCourses()}
      </div>
      <Modal
        isOpen={formModalImage}
        toggle={() => setFormModalImage(!formModalImage)}
        className="modal-dialog-centered modal-xl"
      >
        <ModalHeader toggle={() => setFormModalImage(!formModalImage)} />
        <ModalBody>
          <Card className="ecommerce-card">
            <div className="item-img text-center mx-auto">
              <img
                className="img-fluid card-img-top"
                src={imageView}
                alt={imageView}
              />
            </div>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => setFormModalImage(!formModalImage)}
            outline
          >
            ปิด
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default ProofCards;
